import { render, staticRenderFns } from "./DevelopmentDetails.vue?vue&type=template&id=56783fb4"
import script from "./DevelopmentDetails.vue?vue&type=script&lang=js"
export * from "./DevelopmentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports